import BlueprintPage from './BlueprintPage';
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import BlueprintsPage from './BlueprintsPage';
import BlueprintUploadPage from './BlueprintUploadPage';
import HomePage from './HomePage';
import LoginPage from './LoginPage';
import RegisterPage from './RegisterPage';
import ProjectsPage from './ProjectsPage';
import ProjectPage from './ProjectPage';
import { BoardsListPage } from './BoardsListPage';
import { BoardPage } from './BoardPage';
import ProfileIndexPage from './ProfileIndexPage';
import ProfileActivityPage from './ProfileActivityPage';
import ProfileAccountPage from './ProfileAccountPage';
import ProfilePaymentPage from './ProfilePaymentPage';
import ProfileSubscriptionPage from './ProfileSubscriptionPage';
import AdminPage from './AdminPage';
import DownloadPage from './DownloadPage';
import DesktopAuthCallbackPage from './DesktopAuthCallbackPage';
import PrivacyPage from './legal/PrivacyPage';
import TermsPage from './legal/TermsPage';
import CommunityGuidelinesPage from './legal/CommunityGuidelinesPage';

// Preserve existing shared links while all new navigation uses Blueprints.
export function LegacyBlueprintRedirect() {
  const { pathname, search, hash } = useLocation();
  return (
    <Navigate
      to={`${pathname.replace(/^\/fx-racks(?=\/|$)/, '/blueprints')}${search}${hash}`}
      replace
    />
  );
}

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route
        path="/community-guidelines"
        element={<CommunityGuidelinesPage />}
      />
      <Route path="/register" element={<RegisterPage />} />
      <Route
        path="/desktop-auth-callback"
        element={<DesktopAuthCallbackPage />}
      />
      <Route path="/projects" element={<ProjectsPage />} />
      <Route path="/projects/:projectId" element={<ProjectPage />} />
      <Route path="/fx-racks/*" element={<LegacyBlueprintRedirect />} />
      <Route path="/blueprints" element={<BlueprintsPage />} />
      <Route path="/blueprints/upload" element={<BlueprintUploadPage />} />
      <Route
        path="/blueprints/:blueprintId/edit"
        element={<BlueprintUploadPage />}
      />
      <Route path="/blueprints/:blueprintId" element={<BlueprintPage />} />
      <Route
        path="/blueprints/:blueprintId/versions/new"
        element={<BlueprintUploadPage />}
      />
      <Route path="/boards" element={<BoardsListPage />} />
      <Route path="/boards/:boardId" element={<BoardPage />} />
      <Route path="/profile" element={<ProfileIndexPage />} />
      <Route path="/profile/activity" element={<ProfileActivityPage />} />
      <Route path="/profile/account" element={<ProfileAccountPage />} />
      <Route path="/profile/payment" element={<ProfilePaymentPage />} />
      <Route
        path="/profile/subscription"
        element={<ProfileSubscriptionPage />}
      />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/download" element={<DownloadPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
